<button
  nbButton
  [status]="status"
  [disabled]="disabled"
  [type]="type"
  [size]="size"
  [shape]="shape"
  [ladda]="isLoading"
  [fullWidth] = "fullWidth"
>
  <div *ngIf="icon" class="icon"></div>
  <ng-content></ng-content>
</button>
